import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, UserBlockData } from '../../../../models';
import { UserNodeView } from './UserNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    userNode: { insertUserNode: ({ user }: UserBlockData) => ReturnType };
  }
}

export const UserNode = Node.create({
  name: 'userNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { user: null };
  },

  parseHTML() {
    return [{ tag: BlockTypes.user }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.user, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertUserNode:
        ({ user }: UserBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { user } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(UserNodeView);
  },
});
